<h2 mat-dialog-title class="dialog-title">
    <mat-icon>link_off</mat-icon>
    Desconciliar lançamento do cartão
</h2>

<mat-dialog-content class="dialog-content">

    <div class="extrato-resumo">
        <div>
            <span class="label">DATA</span>
            <span class="value">{{ extrato.dataTransacao | date:'dd/MM/yyyy' }}</span>
        </div>
        <div>
            <span class="label">VALOR</span>
            <span class="value">R$ {{ extrato.valor | abnt }}</span>
        </div>
        <div class="full">
            <span class="label">DESCRIÇÃO</span>
            <span class="value">{{ extrato.memo || '—' }}</span>
        </div>
        @if (extrato.vinculos.length > 0) {
        <div class="full">
            <span class="label">CONCILIADO COM</span>
            @for (v of extrato.vinculos; track $index) {
            <span class="value">{{ v.descricaoVinculo || '(sem descrição)' }}</span>
            }
        </div>
        }
    </div>

    <div class="opcoes-cards">

        <!-- Opção A: Simples -->
        <div class="opcao-card" [class.opcao-card--disabled]="isSalvando">
            <div class="opcao-card-body">
                <h3 class="opcao-titulo">Desconciliar apenas</h3>
                <p class="opcao-descricao">
                    Remove o vínculo de conciliação. A conta a pagar ou movimentação
                    permanecem como estão; apenas o status de conciliado é revertido.
                </p>
            </div>
            <button mat-stroked-button class="btn-secondary w-100" [disabled]="isSalvando"
                (click)="confirmar(TipoDesconciliacaoCartaoEnum.Simples)">
                @if (tipoEmExecucao === TipoDesconciliacaoCartaoEnum.Simples) {
                <mat-spinner diameter="16" class="btn-spinner"></mat-spinner>
                } @else {
                Apenas desvincular
                }
            </button>
        </div>

        <!-- Opção B: Completa -->
        <div class="opcao-card" [class.opcao-card--disabled]="isSalvando">
            <div class="opcao-card-body">
                <h3 class="opcao-titulo">Desconciliar e voltar ao aberto</h3>
                <p class="opcao-descricao">
                    Desfaz tudo: se uma conta a pagar foi criada via conciliação, ela será
                    excluída; se houve pagamento manual depois, a movimentação será estornada.
                </p>
            </div>
            <button mat-flat-button class="btn-primary w-100" [disabled]="isSalvando"
                (click)="confirmar(TipoDesconciliacaoCartaoEnum.Completo)">
                @if (tipoEmExecucao === TipoDesconciliacaoCartaoEnum.Completo) {
                <mat-spinner diameter="16" class="btn-spinner"></mat-spinner>
                } @else {
                Voltar ao aberto
                }
            </button>
        </div>

    </div>

</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
    <button mat-stroked-button class="btn-secondary" [disabled]="isSalvando" (click)="cancelar()">Cancelar</button>
</mat-dialog-actions>
